import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { toolboxApiRef, ToolsCatalogApi } from './api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

export const toolboxPlugin = createPlugin({
  id: 'toolbox',
  apis: [
    createApiFactory({
      api: toolboxApiRef,
      deps: {
        catalogApi: catalogApiRef,
      },
      factory: ({ catalogApi }) => new ToolsCatalogApi(catalogApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const ToolboxPage = toolboxPlugin.provide(
  createRoutableExtension({
    name: 'ToolboxPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
